var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('router-link',{attrs:{"to":'/'}},[_vm._v("\n        Início\n      ")])],1),_vm._v(" "),_vm._l((_vm.links),function(ref){
var named_link = ref.named_link;
var link = ref.link;
var label = ref.label;
return _c('li',{key:label},[(named_link || link)?_c('router-link',{attrs:{"to":named_link ? named_link : link}},[_vm._v("\n        "+_vm._s(label)+" \n      ")]):_vm._e(),_vm._v("\n      "+_vm._s(named_link || link ? '' : label)+"\n    ")],1)})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55371cd2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Breadcrumb.vue
// module id = WiHl
// module chunks = 15